import dynamic from 'next/dynamic'
export default dynamic(() => import('./Debug'), { ssr: false })
